var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDcHazard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m37.78,1.17C17.86,1.17,1.65,17.38,1.65,37.3s16.21,36.12,36.12,36.12,36.12-16.21,36.12-36.12S57.7,1.17,37.78,1.17Zm0,70.25c-18.82,0-34.12-15.31-34.12-34.12S18.96,3.17,37.78,3.17s34.12,15.31,34.12,34.12-15.31,34.12-34.12,34.12Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m55.91,54.63H19.65c-.97,0-1.6-1.02-1.17-1.89l18.13-36.26c.48-.96,1.86-.96,2.34,0l18.13,36.26c.43.87-.2,1.89-1.17,1.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m35.97,42.75l-.63-10.14h4.64l-.63,10.14h-3.38Zm0,5.07v-3.37h3.38v3.37h-3.38Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDcHazard);
export default __webpack_public_path__ + "static/media/dc_hazard.0552ac8a1a5bfd9a84491d20102cc50d.svg";
export { ForwardRef as ReactComponent };